import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';

import { API_BASE_URL } from '../config/api-base-url.token';
import type {
  ApiKeyListResponse,
  ApiKeySummary,
  CreateApiKeyPayload,
  CreateApiKeyResponse,
  UpdateApiKeyPayload,
} from '../models/api-key.models';

@Injectable({ providedIn: 'root' })
export class ApiKeyApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  listApiKeys(): Observable<ApiKeyListResponse> {
    return this.http.get<ApiKeyListResponse>(`${this.baseUrl}/api-keys`);
  }

  createApiKey(payload: CreateApiKeyPayload): Observable<CreateApiKeyResponse> {
    return this.http.post<CreateApiKeyResponse>(`${this.baseUrl}/api-keys`, payload);
  }

  updateApiKey(id: string, payload: UpdateApiKeyPayload): Observable<ApiKeySummary> {
    return this.http.patch<ApiKeySummary>(`${this.baseUrl}/api-keys/${id}`, payload);
  }

  deleteApiKey(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/api-keys/${id}`);
  }
}
